<template>
  <el-container direction="vertical">
    <el-header style="padding: 0" height="">
      <!-- Header content -->
      <el-card class="box-card" :body-style="{ padding: '12px 20px' }">
        <el-row :gutter="0" class="flexLR">
          <el-col :span="19" :offset="0">
            <h2 style="font-weight: bold">数字化BIM体验项目协同平台数据报表</h2>
          </el-col>
          <el-col :span="5" :offset="0">
            <div class="flexLR">
              <div class="flexLR" style="width: 44%">
                <img src="/img/总人数.png" alt="" srcset="" />
                总人数:
                <h3 style="font-weight: bold; font-size: 18">
                  {{ data.projectMember }}
                </h3>
                人
              </div>
              <div class="flexLR" style="width: 44%">
                <img src="/img/今日登录.png" alt="" srcset="" />
                今日登录:
                <h3 style="font-weight: bold; font-size: 18">
                  {{ data.loginSum }}
                </h3>
                人次
              </div>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </el-header>
    <el-container class="flexWarp" direction="horizontal">
      <el-row
        :gutter="0"
        justify="space-around"
        style="height: 15%; margin: 10px 0"
      >
        <el-col :span="5" :offset="0" style="height: 100%; padding-right: 5px">
          <el-card
            shadow="always"
            style="height: 100%"
            :body-style="{ padding: '17px', height: '72%' }"
          >
            <div class="flexWarp" style="height: 100%">
              <div class="flexLR">
                <h3 style="font-weight: bold; font-size: 16px">工单任务</h3>
                <h2 style="font-weight: bold">{{ data.workOrderSum }}</h2>
              </div>
              <div class="flexLR">
                <img src="/img/工单任务.png" alt="" />
                <h2 class="flexLR" style="font-size: 14px">
                  今日新增
                  <h2
                    style="
                      font-weight: bold;
                      color: #6ce770;
                      font-size: 14px;
                      margin: 0 5px;
                    "
                  >
                    {{ data.workOrderUp }}
                  </h2>
                  <img src="/img/arrow1.png" alt="" />
                </h2>
              </div>
            </div>
          </el-card>
        </el-col>
        <!-- <el-col :span="4" :offset="0" style="height:100%;padding: 0 5px;">
          <el-card
            shadow="always"
            style="height:100%"
            :body-style="{ padding: '17px', height: '72%' }"
          >
            <div class="flexWarp" style="height: 100%;">
              <div class="flexLR">
                <h3 style="font-weight:bold;font-size:16px;">流程表单</h3>
                <h2 style="font-weight: bold;">513</h2>
              </div>
              <div class="flexLR">
                <img src="/img/流程表单.png" alt="" />
                <h2 class="flexLR" style="font-size: 14px;">
                  今日新增
                  <h2
                    style="font-weight: bold;color: #ff5043;font-size: 14px;margin: 0 5px;"
                  >
                    513
                  </h2>
                  <img src="/img/arrow-up.png" alt="" />
                </h2>
              </div>
            </div>
          </el-card>
        </el-col> -->
        <el-col :span="5" :offset="0" style="height: 100%; padding: 0 5px">
          <el-card
            shadow="always"
            style="height: 100%"
            :body-style="{ padding: '17px', height: '72%' }"
          >
            <div class="flexWarp" style="height: 100%">
              <div class="flexLR">
                <h3 style="font-weight: bold; font-size: 16px">动态贴</h3>
                <h2 style="font-weight: bold">{{ data.DynamicSum }}</h2>
              </div>
              <div class="flexLR">
                <img src="/img/动态贴.png" alt="" />
                <h2 class="flexLR" style="font-size: 14px">
                  今日新增
                  <h2
                    style="
                      font-weight: bold;
                      color: #738bfe;
                      font-size: 14px;
                      margin: 0 5px;
                    "
                  >
                    {{ data.DynamicUp }}
                  </h2>
                  <img src="/img/arrow3.png" alt="" />
                </h2>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="5" :offset="0" style="height: 100%; padding: 0 5px">
          <el-card
            shadow="always"
            style="height: 100%"
            :body-style="{ padding: '17px', height: '72%' }"
          >
            <div class="flexWarp" style="height: 100%">
              <div class="flexLR">
                <h3 style="font-weight: bold; font-size: 16px">讨论</h3>
                <h2 style="font-weight: bold">{{ data.topicSum }}</h2>
              </div>
              <div class="flexLR">
                <img src="/img/讨论.png" alt="" />
                <h2 class="flexLR" style="font-size: 14px">
                  今日新增
                  <h2
                    style="
                      font-weight: bold;
                      color: #0098ff;
                      font-size: 14px;
                      margin: 0 5px;
                    "
                  >
                    {{ data.topicUp }}
                  </h2>
                  <img src="/img/arrow4.png" alt="" />
                </h2>
              </div>
            </div>
          </el-card>
        </el-col>
        <el-col :span="5" :offset="0" style="height: 100%; padding: 0 5px">
          <el-card
            shadow="always"
            style="height: 100%"
            :body-style="{ padding: '17px', height: '72%' }"
          >
            <div class="flexWarp" style="height: 100%">
              <div class="flexLR">
                <h3 style="font-weight: bold; font-size: 16px">项目资料</h3>
                <h2 style="font-weight: bold">{{ data.fileSum }}</h2>
              </div>
              <div class="flexLR">
                <img src="/img/工程资料.png" alt="" />
                <h2 class="flexLR" style="font-size: 14px">
                  今日新增
                  <h2
                    style="
                      font-weight: bold;
                      color: #fc8d3f;
                      font-size: 14px;
                      margin: 0 5px;
                    "
                  >
                    {{ data.fileUp }}
                  </h2>
                  <img src="/img/arrow5.png" alt="" />
                </h2>
              </div>
            </div>
          </el-card>
        </el-col>
        <!-- <el-col :span="4" :offset="0" style="height: 100%; padding-left: 5px">
          <el-card
            shadow="always"
            style="height: 100%"
            :body-style="{ padding: '17px', height: '72%' }"
          >
            <div class="flexWarp" style="height: 100%">
              <div class="flexLR">
                <h3 style="font-weight: bold; font-size: 16px">图纸资料</h3>
                <h2 style="font-weight: bold">{{ data.drawSum }}</h2>
              </div>
              <div class="flexLR">
                <img src="/img/图纸资料.png" alt="" />
                <h2 class="flexLR" style="font-size: 14px">
                  今日新增
                  <h2
                    style="
                      font-weight: bold;
                      color: #01c8ab;
                      font-size: 14px;
                      margin: 0 5px;
                    "
                  >
                    {{ data.drawUp }}
                  </h2>
                  <img src="/img/arrow6.png" alt="" />
                </h2>
              </div>
            </div>
          </el-card>
        </el-col> -->
      </el-row>
      <div style="height: 85%">
        <div class="flexLR" style="height: 100%; align-items: start">
          <div class="flexWarp" style="width: 75%; height: 100%">
            <div class="flexLR" style="height: 49%">
              <el-card
                shadow="always"
                v-loading="loading"
                style="height: 100%; width: 100%"
                :body-style="{ padding: '10px 20px', height: '94%' }"
              >
                <div class="flexWarp" style="height: 100%">
                  <div
                    class="flexLR"
                    style="justify-content: start; height: 10%"
                  >
                    <h3
                      style="
                        font-weight: bold;
                        font-size: 16px;
                        margin-right: 20px;
                      "
                    >
                      进度计划
                    </h3>
                    <el-select
                      filterable
                      placeholder="计划选择"
                      @change="planChange"
                      v-model="selectValue"
                      size="mini"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.pjpl01"
                        :label="item.pjpl03"
                        :value="item.pjpl01"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="flexLR" style="height: 82%; align-items: start">
                    <div
                      class="flexLR"
                      style="
                        flex-wrap: wrap;
                        width: 65%;
                        height: 100%;
                        justify-content: start;
                      "
                    >
                      <div style="width: 33.3%; margin-bottom: 10px">
                        <div class="flexLR" style="justify-content: start">
                          <img
                            src="/img/子计划数.png"
                            alt=""
                            style="margin-right: 10px"
                          />
                          <div>
                            <h2 style="font-size: 14px; font-weight: bold">
                              {{ dataList.plandetailList.length }}
                            </h2>
                            <h4 style="color: #c1c1c1">子计划数</h4>
                          </div>
                        </div>
                      </div>
                      <div style="width: 33.3%; margin-bottom: 10px">
                        <div class="flexLR" style="justify-content: start">
                          <img
                            src="/img/已完成延期.png"
                            alt=""
                            style="margin-right: 10px"
                          />
                          <div>
                            <h2 style="font-size: 14px; font-weight: bold">
                              {{
                                dataList.plandetailList.filter(
                                  (el) => el.State == "已完成（延期）"
                                ).length
                              }}
                            </h2>
                            <h4 style="color: #c1c1c1">已完成延期</h4>
                          </div>
                        </div>
                      </div>
                      <div style="width: 33.3%; margin-bottom: 10px">
                        <div class="flexLR" style="justify-content: start">
                          <img
                            src="/img/执行中.png"
                            alt=""
                            style="margin-right: 10px"
                          />
                          <div>
                            <h2 style="font-size: 14px; font-weight: bold">
                              {{
                                dataList.plandetailList.filter(
                                  (el) => el.State == "执行中"
                                ).length
                              }}
                            </h2>
                            <h4 style="color: #c1c1c1">执行中</h4>
                          </div>
                        </div>
                      </div>
                      <div style="width: 33.3%; margin-bottom: 10px">
                        <div class="flexLR" style="justify-content: start">
                          <img
                            src="/img/执行中延期.png"
                            alt=""
                            style="margin-right: 10px"
                          />
                          <div>
                            <h2 style="font-size: 14px; font-weight: bold">
                              {{
                                dataList.plandetailList.filter(
                                  (el) => el.State == "执行中（延期）"
                                ).length
                              }}
                            </h2>
                            <h4 style="color: #c1c1c1">执行中延期</h4>
                          </div>
                        </div>
                      </div>
                      <div style="width: 33.3%; margin-bottom: 10px">
                        <div class="flexLR" style="justify-content: start">
                          <img
                            src="/img/已完成提前.png"
                            alt=""
                            style="margin-right: 10px"
                          />
                          <div>
                            <h2 style="font-size: 14px; font-weight: bold">
                              {{
                                dataList.plandetailList.filter(
                                  (el) => el.State == "已完成（提前）"
                                ).length
                              }}
                            </h2>
                            <h4 style="color: #c1c1c1">已完成提前</h4>
                          </div>
                        </div>
                      </div>
                      <div style="width: 33.3%; margin-bottom: 10px">
                        <div class="flexLR" style="justify-content: start">
                          <img
                            src="/img/已完成.png"
                            alt=""
                            style="margin-right: 10px"
                          />
                          <div>
                            <h2 style="font-size: 14px; font-weight: bold">
                              {{
                                dataList.plandetailList.filter(
                                  (el) => el.State == "已完成"
                                ).length
                              }}
                            </h2>
                            <h4 style="color: #c1c1c1">已完成</h4>
                          </div>
                        </div>
                      </div>
                      <div style="width: 33.3%; margin-bottom: 10px">
                        <div class="flexLR" style="justify-content: start">
                          <img
                            src="/img/未启动延期.png"
                            alt=""
                            style="margin-right: 10px"
                          />
                          <div>
                            <h2 style="font-size: 14px; font-weight: bold">
                              {{
                                dataList.plandetailList.filter(
                                  (el) => el.State == "未启动（延期）"
                                ).length
                              }}
                            </h2>
                            <h4 style="color: #c1c1c1">未启动延期</h4>
                          </div>
                        </div>
                      </div>
                      <div style="width: 33.3%; margin-bottom: 10px">
                        <div class="flexLR" style="justify-content: start">
                          <img
                            src="/img/未启动.png"
                            alt=""
                            style="margin-right: 10px"
                          />
                          <div>
                            <h2 style="font-size: 14px; font-weight: bold">
                              {{
                                dataList.plandetailList.filter(
                                  (el) => el.State == "未启动"
                                ).length
                              }}
                            </h2>
                            <h4 style="color: #c1c1c1">未启动</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div style="width: 35%; height: 100%">
                      <v-chart
                        theme="macarons"
                        style="width: 95%; height: 100%; margin: 0 auto"
                        :options="aqglOption"
                      ></v-chart>
                    </div>
                  </div>
                </div>
              </el-card>
            </div>
            <div class="flexLR" style="height: 49%">
              <el-card
                shadow="always"
                style="height: 100%; width: 100%"
                :body-style="{ padding: '15px 20px', height: '95%' }"
              >
                <h3 style="font-weight: bold; font-size: 16px">
                  最近7日登陆统计
                </h3>
                <v-chart
                  theme="macarons"
                  style="width: 95%; height: 95%; margin: 0 auto"
                  :options="loginOption"
                ></v-chart>
              </el-card>
            </div>
          </div>
          <div style="width: 24.5%; height: 100%">
            <el-card
              shadow="always"
              style="height: 100%"
              :body-style="{ padding: '15px 20px', height: '95%' }"
            >
              <div class="flexWarp" style="height: 100%">
                <h3 style="font-weight: bold; font-size: 16px">项目条码</h3>
                <div
                  class="flexWarp"
                  style="
                    height: 50%;
                    margin: 30px 0;
                    overflow: auto;
                    justify-content: normal;
                  "
                >
                  <div
                    class="flexLR"
                    :style="{
                      borderRight: '6px solid ' + item.color,
                      marginBottom: '10px',
                      background: 'linear-gradient(90deg, #fdfdfd, #cdcdcd1a)',
                      padding: '15px',
                    }"
                    v-for="(item, index) in data.projectBar"
                    :key="index"
                  >
                    <el-color-picker
                      v-model="item.color"
                      disabled
                    ></el-color-picker>
                    <span
                      style="margin-left: 10px; color: #898989; width: 100%"
                      >{{ item.name }}</span
                    >
                    <h2
                      :style="{
                        width: '25%',
                        color: item.color,
                        fontWeight: 'bold',
                      }"
                    >
                      {{ item.val
                      }}<span
                        style="
                          margin-left: 5px;
                          font-size: 10px;
                          color: #c1c1c1;
                        "
                        >个</span
                      >
                    </h2>
                  </div>
                </div>
                <h3 style="font-weight: bold; font-size: 16px; height: 10px">
                  实景管理
                </h3>
                <div
                  class="flexWarp"
                  style="
                    height: 50%;
                    margin: 30px 0;
                    overflow: auto;
                    justify-content: normal;
                  "
                >
                  <div
                    class="flexLR"
                    :style="{
                      borderRight: '6px solid ' + item.color,
                      marginBottom: '10px',
                      background: 'linear-gradient(90deg, #fdfdfd, #cdcdcd1a)',
                      padding: '15px',
                    }"
                    v-for="(item, index) in data.scenceManager"
                    :key="index"
                  >
                    <div>
                      <img
                        :src="$store.state.baseUrl + item.pic"
                        alt=""
                        width="40px"
                        height="40px"
                      />
                    </div>
                    <span
                      style="margin-left: 10px; color: #898989; width: 100%"
                      >{{
                        item.name == 1
                          ? "图片"
                          : item.name == 2
                          ? "全景"
                          : "视频"
                      }}</span
                    >
                    <h2
                      :style="{
                        width: '25%',
                        color: item.color,
                        fontWeight: 'bold',
                      }"
                    >
                      {{ item.val
                      }}<span
                        style="
                          margin-left: 5px;
                          font-size: 10px;
                          color: #c1c1c1;
                        "
                        >个</span
                      >
                    </h2>
                  </div>
                </div>
              </div>
            </el-card>
          </div>
        </div>
      </div>
    </el-container>
  </el-container>
</template>

<script>
import { ProjectDataBoard, GetPlanListNoJd, Get3DSimulate } from "@/setAxios";
export default {
  name: "DataBoard",
  data() {
    return {
      selectValue: null,
      aqglOption: {
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: "5%",
          left: "center",
        },
        series: [
          {
            type: "pie",
            radius: ["50%", "70%"],
            center: ["50%", "40%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 30,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 0, name: "已完成" },
              { value: 0, name: "进行中" },
            ],
          },
        ],
      },
      loginOption: {
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        },
        grid: {
          left: "5%",
          bottom: "12%",
          right: "0",
        },
        yAxis: {
          type: "value",
        },
        tooltip: {
          trigger: "axis",
        },
        series: [
          {
            name: "登录人次",
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: "line",
            smooth: true,
          },
        ],
      },
      data: {},
      options: [],
      dataList: {
        plandetailList: [],
      },
      loading: false,
    };
  },
  watch: {},
  created() {
    this.getData();
    setTimeout(() => {
      this.GetPlanListNoJd();
    }, 500);
  },
  mounted() {},
  methods: {
    planChange(i) {
      this.selectValue = i;
      this.Get3DSimulate();
    },
    Get3DSimulate() {
      this.loading = true;
      let params = {
        planid: this.selectValue,
      };
      Get3DSimulate(params).then((res) => {
        this.loading = false;
        this.dataList = res.Data;
        if (res.Data.plandetailList) {
          this.aqglOption.series[0].data[0].value =
            res.Data.plandetailList.filter((el) =>
              el.State.includes("已完成")
            ).length;
          this.aqglOption.series[0].data[1].value =
            res.Data.plandetailList.length -
            this.aqglOption.series[0].data[0].value;
        }
      });
    },
    GetPlanListNoJd() {
      let params = {
        xid: localStorage.xid,
        userid: localStorage.id,
      };
      GetPlanListNoJd(params).then((res) => {
        this.options = res.Data;
        this.selectValue = res.Data[0].pjpl01;
        this.Get3DSimulate();
      });
    },
    getData() {
      let params = {
        xid: this.$store.state.xid,
      };
      ProjectDataBoard({ params }).then((res) => {
        this.data = res.Data;
        res.Data.login7d = res.Data.login7d.reverse();
        this.loginOption.xAxis.data = res.Data.login7d.map((x) => x.time);
        this.loginOption.series[0].data = res.Data.login7d.map((x) =>
          Number(x.val)
        );
      });
    },
  },
};
</script>

<style lang="less" scoped>
.flexWarp {
  height: 70%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
/deep/.el-color-picker__mask {
  background-color: rgba(255, 255, 255, 0) !important;
}
</style>
